import {Button, DialogTrigger} from 'react-aria-components'

import UserSvg from '@/assets/icons/user.svg?react'
import {useAccountInformationValue} from '@/auth/hooks/useAccountInformation'
import ThemeSwitcher from '@/components/ThemeSwitcher/ThemeSwitcher'
import CountrySelector from '@/lib/locale/components/CountrySelector'

import CartLink from './CartLink'
import style from './NavbarEnd.module.scss'

const UserMenuPopover = lazy(async () => await import('./NavbarEnd/UserMenuPopover'))

interface Props {
  variant?: 'light' | 'dark'
  haveCart?: boolean
  transparentBg?: boolean
}

export default memo<Props>(function NavbarEnd(props) {
  const [isUserDropdownShow, setIsUserDropdownShow] = useState(false)

  const variant = props.variant
  const account = useAccountInformationValue()
  const transparentBg = props.transparentBg

  let nameAbbr

  try {
    if (account) {
      const name = account.accountName.split(' ')
      // @ts-expect-error errors are caught
      nameAbbr = name[0][0] + name[1][0]
    }
  } catch (e) {
    console.error('Cannot read name', e)
  }

  return (
    <nav>
      <ul className={clsx(style.NavbarEnd, variant === 'dark' && style.Dark)}>
        {props.haveCart && (
          <li>
            <CartLink
              className={clsx(style.NavbarLink, transparentBg && style.Transparent)}
              activeClassName={style.IsActive}
            />
          </li>
        )}
        <li className={clsx(style.ButtonWrapper, nameAbbr && style.AccountName)}>
          <DialogTrigger>
            <Button
              className={style.Button}
              aria-label='User menu'
              onPress={() => {
                setIsUserDropdownShow(true)
              }}
            >
              {nameAbbr ?? <UserSvg aria-hidden />}
            </Button>
            <Suspense>
              <UserMenuPopover
                isUserDropdownShow={isUserDropdownShow}
                setIsUserDropdownShow={setIsUserDropdownShow}
              />
            </Suspense>
          </DialogTrigger>
        </li>
        <li>
          <CountrySelector variant={variant} />
        </li>
        <li>
          <ThemeSwitcher />
        </li>
      </ul>
    </nav>
  )
})
